import { getWikoErrorFromJsonRpcError } from '@wiko/errors';
import { RpcResponseTransformer } from '@wiko/rpc-spec-types';

type JsonRpcResponse = { error: Parameters<typeof getWikoErrorFromJsonRpcError>[0] } | { result: unknown };

export function getThrowWikoErrorResponseTransformer(): RpcResponseTransformer {
    return json => {
        const jsonRpcResponse = json as JsonRpcResponse;
        if ('error' in jsonRpcResponse) {
            throw getWikoErrorFromJsonRpcError(jsonRpcResponse.error);
        }
        return jsonRpcResponse;
    };
}
